var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.562 0C14.3446 2.84637 17.0287 5.81724 19.1996 9.14909C22.425 14.0987 24.933 20.0577 20.962 25.3988C16.2832 31.6922 6.11369 31.5066 1.74399 24.9885C-1.47424 20.1885 0.260193 15.0799 2.94351 10.5335C5.23927 6.641 8.28213 3.23162 11.4419 0H11.562ZM11.5019 26.2594V5.68569C10.4706 6.7334 9.52329 7.89387 8.63606 9.06687C5.33536 13.4308 0.669377 20.8658 6.99852 24.9486C8.32456 25.8044 9.91085 26.261 11.5019 26.2594Z",
    fill: "#295860"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.057f2b39f03e63e41a55094a9a60c3d0.svg";
export { ForwardRef as ReactComponent };